<template>
  <div class="modal__container" :class="{ '--dark': darkMode || darkBackground }">

    <b v-if="topText.length > 0" class="modal__top-text">
      <span>{{ topText }}</span>
    </b>
    <tw-card
      class="modal__card"
      :dark-mode="darkMode"
      no-padding
      :style="[
        { 'border-radius': (rounded ? '16px !important' : '8px') }
      ]"
    >
      <div
          v-if="closeModalStyle === 'close-icon'"
          @click="() => { emitCloseModal(); }"
          style="position: absolute; top: 8px; right: 8px;"
      >
        <icon-close size="32" class="text-gray-500" />
      </div>
      <div
        v-else-if="closeModalStyle === 'close-btn'"
        @click="() => { emitCloseModal(); }"
        style="position: absolute; top: 12px; right: 12px; border-radius: 50%; padding: 6px; background-color: #242526; border: 1px solid #333435; cursor: pointer"
      >
        <icon-close size="22" style="color: #ededed" />
      </div>
      <slot />
    </tw-card>

    <div
      v-if="closeModalStyle === 'bottom-text'"
      @click="() => { emitCloseModal(); }"
      class="modal__bottom-text"
    >
      <slot name="bottom-text" />
    </div>

    <div @click="() => { if(dismissibleModal) { emitCloseModal(); }}" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; pointer-events: all; background: transparent"></div>
  </div>
</template>

<script>
import TwCard from "@/components/Tailwind/TwCard.vue";
import IconClose from "@/components/Icon/IconClose.vue";

export default {
  name: "TwModal",
  components: {IconClose, TwCard },
  props: {
    dismissibleModal: {
      type: Boolean,
      default: false
    },
    closeModalStyle: {
      type: String,
      default: ""
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    darkBackground: {
      type: Boolean,
      default: false
    },
    topText: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    document.body.style.overflow = "hidden";
    document.body.style.pointerEvents = "none";
  },
  methods: {
    emitCloseModal: function () {
      document.body.style.overflow = "inherit";
      document.body.style.pointerEvents = "inherit";
      this.$emit('close-modal');
    }
  }
}

</script>

<style scoped>
.modal__container {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.45);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 1rem 1.5rem 88px;
}
.modal__container.--dark {
  background-color: rgba(0, 0, 0, 0.9);
}
.modal__card {
  z-index: 1000000;
  width: 100%;
  max-width: 1024px;
  position: relative;
  margin: 0 auto;
  overflow: auto;
  pointer-events: all;
}
.modal__top-text {
  font-weight: 500;
  font-size: 0.7rem;
  text-align: left;
  width: 100%;
  padding-bottom: 0.125rem;
  color: #ddd;
  max-width: 1024px
}
.modal__bottom-text {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  position: relative;
  margin-top: 64px;
  z-index: 100000000;
  pointer-events: all;
  color: #bdbdbd !important;
  font-size: 13px
}

.disable-scrollbars::-webkit-scrollbar {
  background: transparent;
  width: 0px;
}
.disable-scrollbars {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.q-animate--scale {
  animation: none !important;
}
</style>
